import { ReactElement, useState } from "react";
import { useHistory } from "react-router-dom";
import { DropdownButton } from "@jsq/ds/core";
import { useFeatureFlag } from "@jsq/flags-react";
import { globalEnv } from "~/global-env";
import { ExportSuccessModal } from "~/pages/FundAccounting/Arenas/TransactionExport/ExportSuccessModal";
import { TransactionExportModal } from "./TransactionExportModal";

export const TransactionExport = (): ReactElement => {
  const history = useHistory();
  const showTransactionLookupFF = useFeatureFlag("showTransactionLookup", false);
  const [isTransactionExportModelOpen, setIsTransactionExportModelOpen] = useState(false);
  const [isExportSuccessModalOpen, setIsExportSuccessModalOpen] = useState(false);

  const closeExportModal = () => {
    setIsTransactionExportModelOpen(false);
  };
  const closeExportSuccessModal = () => {
    setIsExportSuccessModalOpen(false);
  };
  const handleButtonClick = () => {
    setIsTransactionExportModelOpen(true);
  };
  const openExportSuccessModal = () => {
    setIsExportSuccessModalOpen(true);
  };
  const handleOpenTransactionLookup = () => {
    history.push(`${globalEnv.fundAccountingRoute}/transaction-lookup`);
  };

  return (
    <>
      <DropdownButton label="Export" align="right">
        <DropdownButton.Action onSelect={handleButtonClick}>
          Transactions change report
        </DropdownButton.Action>
        {showTransactionLookupFF && (
          <DropdownButton.Action onSelect={handleOpenTransactionLookup}>
            GL transaction lookup
          </DropdownButton.Action>
        )}
      </DropdownButton>
      <TransactionExportModal
        isOpen={isTransactionExportModelOpen}
        onClose={closeExportModal}
        openSuccessModal={openExportSuccessModal}
      />
      <ExportSuccessModal isOpen={isExportSuccessModalOpen} onClose={closeExportSuccessModal} />
    </>
  );
};
